export class EditCompanyInfoModel {
  public id:string;
  public companyName: string;
  public address: string;
  public email: string;
  public phone: string;
  public countryId: number;  
  public businessTypesCompanies: Array<number> = new Array<number>();
}
